import { FC } from 'react';
import classNames from 'classnames';
import styles from './index.less';


export interface TagProps {
  type?: 'default' | 'primary' | 'success' | 'error' | 'warning' | 'processing';
  size?: 'middle' | 'small' | 'large';
  disabled?: boolean;
  children: string;
}

const Tag: FC<TagProps> = ({
  type = 'default',
  disabled,
  children
}) =>
  <span className={classNames(
    styles.tag,
    styles[type]
  )}>
    {children}
  </span>

export default Tag;
